import { render } from "./namespace.vue?vue&type=template&id=600df4f2"
import script from "./namespace.vue?vue&type=script&lang=js"
export * from "./namespace.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__